import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";

function EditSchoolGroupModal({ show, onHide, group, onSubmit, loading }) {
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (group) {
      setName(group.name || "");
    }
  }, [group]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      setNameError("Group name is required");
      return;
    }

    setSubmitting(true);
    try {
      await onSubmit({ name: name.trim() });
      setNameError(null);
    } catch (err) {
      console.error("Error submitting form:", err);
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setName(group?.name || "");
    setNameError(null);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit School Group</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Group Name</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                if (nameError) setNameError(null);
              }}
              isInvalid={!!nameError}
              disabled={submitting || loading}
              autoFocus
            />
            <Form.Control.Feedback type="invalid">
              {nameError}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={submitting || loading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={submitting || loading}>
          {submitting ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Saving...
            </>
          ) : (
            "Save Changes"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditSchoolGroupModal;
